import { create } from "zustand";
import {
  InvoiceStatusEnumType,
  InvoiceTypeEnumType,
} from "@sellar-io/api-v2/types";

type InvoicesFilterState = {
  status: InvoiceStatusEnumType | "all";
  type: InvoiceTypeEnumType | "all";
  setStatus: (status: InvoiceStatusEnumType | "all") => void;
  setType: (type: InvoiceTypeEnumType | "all") => void;
  reset: () => void;
  setState: (state: InvoicesFilterState) => void;
};

export const useInvoicesFilterStore = create<InvoicesFilterState>((set) => ({
  status: "all",
  type: "all",
  setStatus: (status) => set({ status }),
  setType: (type) => set({ type }),
  reset: () => set({ status: "all", type: "all" }),
  setState: (state) => set(state),
}));
